import { api } from "~/utils/api";

export const useSession = () => {
  const { data: user } = api.auth.me.useQuery(undefined, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });

  const { data: organization } = api.organization.get.useQuery(undefined, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });

  return { user, organization };
};
